import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Endpoints } from '@shared/Endpoints';
import { TSalesRegion } from '@shared/interfaces/TProject';
import { TSearchAllParams } from '@shared/interfaces/TSearchAllParams';
import { TSearchGroup } from '@shared/interfaces/TSearchGroup';
import { ProjectRegions, UserLevel } from '@shared/interfaces/TUser';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService, TCurrentUser } from './auth.service';
import { LoadingService } from './loading.service';
import { RegionsService, WORLD_REGION } from './regions.service';
@Injectable()
export class SearchService {
  private _searchResults: BehaviorSubject<TSearchGroup[]> = new BehaviorSubject<
    TSearchGroup[]
  >([]);

  constructor(
    private _http: HttpClient,
    private _loadingService: LoadingService,
    private _regionsService: RegionsService,
    private _authService: AuthService
  ) {}

  public getSearchResultsObservable(): Observable<TSearchGroup[]> {
    return this._searchResults.asObservable();
  }

  public performSearch(text: string = '', projectId: string = ''): void {
    const url: string = Endpoints.BUILD_URL('rise', {
      base: environment.apiUrl,
      endpoint: 'searchAll',
      params: '',
    });
    const regions: string[] = this._regionsService
      .getSelectedCountries()
      .map((r) => r.value);
    const { showAllCountries, countries } = this.buildCountries(regions);
    const body: TSearchAllParams = {
      text,
      projectId,
      countries,
      showAllCountries,
    };
    const response = this._http.post<TSearchGroup[]>(url, body);
    response.subscribe({
      error: (err) => {
        console.error(err);
        this._loadingService.onError();
      },
      next: (response) => {
        this._searchResults.next(response);
      },
    });
  }

  public getSearchResults(projectId: string): Observable<TSearchGroup[]> {
    const url: string = Endpoints.BUILD_URL('rise', {
      base: environment.apiUrl,
      endpoint: 'searchAll',
      params: '',
    });
    const regions: string[] = this._regionsService
      .getSelectedCountries()
      .map((r) => r.value);
    const { showAllCountries, countries } = this.buildCountries(regions);

    let body: TSearchAllParams = {
      text: '',
      projectId,
      countries,
      showAllCountries,
    };

    const projectRegions = this.buildProjectRegions(projectId);
    body.projectRegions = projectRegions;

    const response = this._http.post<TSearchGroup[]>(url, body);
    return response;
  }

  private _filter(opt: string[], value: string): string[] {
    const filterValue = value.toLowerCase();
    return opt.filter((item) => item.toLowerCase().includes(filterValue));
  }

  private buildCountries(regions: string[]): {
    showAllCountries: boolean;
    countries: string[];
  } {
    const currentUser: TCurrentUser = this._authService.getCurrentUser();
    const isAdmin = currentUser?.level === UserLevel.Admin;
    const showAllCountries =
      isAdmin || (currentUser?.countries || []).length === 0;
    return {
      showAllCountries: showAllCountries,
      countries: regions.includes(WORLD_REGION.value) ? [] : regions,
    };
  }

  private buildProjectRegions(projectId: string) {
    let projectRegions = {
      filter: false,
      filterBy: [] as string[],
    };
    const currentUser: TCurrentUser = this._authService.getCurrentUser();
    const userRegions = currentUser?.projectsRegions?.find((pr: ProjectRegions) => pr.projectId === projectId)?.regions.map((reg: TSalesRegion) => reg.id) ?? [];

    projectRegions = {
      filter: currentUser?.level !== UserLevel.Admin && userRegions.length > 0,
      filterBy: userRegions,
    };

    return projectRegions;
  }
}
